export enum OrderKind {
  Emergency = 'Emergency',
  Forecast = 'Forecast',
}